import { ref, computed,onMounted } from "vue"
import { useStore } from "vuex"

// TinyMCE imports
import "tinymce/tinymce"
import "tinymce/themes/silver";
import "tinymce/icons/default";
import 'tinymce/models/dom/model'
import 'tinymce/skins/ui/oxide/skin.css';
// TinyMCE plugin imports
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/autolink';

import Editor from '@tinymce/tinymce-vue'
import AttachmentsEditor from "../AttachmentsEditor/AttachmentsEditor.vue";

export default {
    name: "PostHeaderAddComment",
    components: {
        AttachmentsEditor,
        Editor
    },
    props: {
        postId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const newCommentContent = ref('')
        const newCommentFilesToAdd = ref([])
        const attachmentsComponent = ref()
        const isSubmitting = ref(false)
        const isSubmitButtonDisabled = computed(() => newCommentContent.value.length === 0 || isSubmitting.value)

        const submitNewComment = async () => {

            if (newCommentContent.value === '') {
                return
            }

            sessionStorage.setItem("scrollPosition", window.scrollY);
            isSubmitting.value = true

            let formData = new FormData()
            if (newCommentContent.value !== '') {
                formData.append('htmlComment', newCommentContent.value)
            }
            
            newCommentFilesToAdd.value.forEach(file => {
                formData.append('file', file)
            })

            formData.append('postId', props.postId)

            await store.dispatch('forum/submitNewComment', {
                id: props.postId,
                body: formData
            })
            const getposts = await store.dispatch('forum/getPostComments',{
                postId: props.postId,
                pageId: store.state.main.page_id
            })
            newCommentContent.value = ""
            attachmentsComponent.value?.clear()
            isSubmitting.value = false
           
        }

        const getLabel = (labelKey) => store.getters['labels/getLabel']({labelCollection: 'PostHeaderAddComment', labelKey})

        return {
            getLabel,
            submitNewComment,
            newCommentContent,
            newCommentFilesToAdd,
            isSubmitButtonDisabled,
            attachmentsComponent
        }
    }
}